module.exports = __webpack_public_path__ + "img/IMMERSE_FX_LOGO_WHITE_BLACK.2c4e991b.svg";